import { EmptyStatePageState, EmptyStatePageStateOverride } from './model'
import { Dispatch } from '../../types'

/**
 *  Action Constants
 */
export const ChangeEmptyState = 'Monitoring/EmptyStatePage/ChangeEmptyState'

/**
 *  Action Type
 */
export type ChangeEmptyStateAction = {
  type: 'Monitoring/EmptyStatePage/ChangeEmptyState'
  payload: EmptyStatePageState
}

/**
 *  Action Creators
 */
export const changeEmptyStateAction = (emptyState: EmptyStatePageState): ChangeEmptyStateAction => ({
  type: ChangeEmptyState,
  payload: {
    is404: emptyState.is404,
    emptyStateTitle: emptyState.emptyStateTitle,
    emptyStateSubtitle: emptyState.emptyStateSubtitle,
    redirectLink: emptyState.redirectLink
  }
})

export const changeEmptyState = (errorStatusCode?: number, overrideEmptyState?: EmptyStatePageStateOverride) => (dispatch: Dispatch) => {
  let emptyState: EmptyStatePageState
  
  switch (errorStatusCode) {
    case 302:
      emptyState = {
        is404: false,
        emptyStateTitle: 'The dashboard you are looking is in a different Business Group.',
        emptyStateSubtitle: `Please select the right business group and try again. Contact your organization administrator for more information.`,
        redirectLink: {
          label: 'Back to Custom Dashboards',
          href: '#/dashboard'
        },
        ...overrideEmptyState
      }
      break
    
    case 404:
    default:
      emptyState = {
        is404: true,
        emptyStateTitle: 'The dashboard you are looking for could not be found.',
        emptyStateSubtitle: `Either it doesn't exist or it was deleted. Contact your organization administrator for more information.`,
        redirectLink: {
          label: 'Back to Custom Dashboards',
          href: '#/dashboard'
        },
        ...overrideEmptyState
      }
      break
  }
  
  dispatch(changeEmptyStateAction(emptyState))
  
  window.location.hash = '/empty-state'
}

export const handleRedirection = (href: string) => () => {
  if (href) {
    window.location.href = href
  }
}

export type EmptyStateActions =
  | ChangeEmptyStateAction
